import React, { useState } from 'react';
import { uniq } from 'underscore';
import { Button, Modal } from 'react-bootstrap';
import Alert from 'components/ui/Alert';
import Spinner from 'components/ui/Spinner';
import validator from 'email-validator';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import CargomaticInput from '../../v2/input';
export default function SendEmailModal({ show, action, onSend, onHide }) {
    const [showModal] = useState(show || false);
    const [modalTitle] = useState(action || '');
    const [recipients, setRecipient] = useState('');
    const [error, setError] = useState('');
    const [enableSend, setEnableSend] = useState(false);
    const [sending, setSending] = useState(false);
    const { t } = useTranslation();
    const handleSend = async () => {
        try {
            const emails = recipients.replace(/' '/g, '').split(',');
            if (enableSend) {
                setSending(true);
                await onSend(uniq(emails));
                setSending(false);
                setRecipient('');
            }
        }
        catch (e) {
            setSending(false);
            throw e;
        }
    };
    const handleSetRecipients = (value) => {
        setRecipient(value);
        const emails = recipients.replace(/' '/g, '').split(',');
        const filtered = emails.filter(Boolean);
        const invalidEmailAddresses = filtered.filter((ea) => !validator.validate(ea));
        if (invalidEmailAddresses.length > 0) {
            setError(t('VALID_EMAIL_ONLY'));
            setEnableSend(false);
        }
        else {
            setError('');
            setEnableSend(true);
        }
    };
    const renderError = () => {
        if (!error) {
            return '';
        }
        return React.createElement(Alert, { type: "warning" }, error);
    };
    return (React.createElement(Modal, { show: showModal, onHide: onHide },
        React.createElement(Modal.Header, null,
            React.createElement("strong", null, modalTitle)),
        React.createElement(Modal.Body, null,
            React.createElement("div", { className: "flex flex-col" },
                React.createElement(CargomaticInput, { className: "my-auto", error: error, label: titleize(t('RECIPIENT', { count: 2 })), info: titleize(t('RECIPIENT', { count: 2 })), placeholder: t('COMMA_SEPARATED_EMAIL_ADDRESSES'), onChange: handleSetRecipients, value: recipients }),
                React.createElement("div", { className: "h-12 mt-4" }, error && renderError()))),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { bsStyle: "danger", type: "button", onClick: onHide }, t('CLOSE')),
            React.createElement(Button, { disabled: !enableSend, bsStyle: "primary", type: "button", onClick: handleSend }, sending ? React.createElement(Spinner, { showMessage: false }) : t('SEND')))));
}
